module.exports = "files/super-mario-world.png";